import notFoundDecorSvg from '@/assets/images/not-found-page-decorator.svg'
import PrimaryButton from '@/components/PrimaryButton/PrimaryButton'
import Navbar from '@/layout/Navbar'
import HeadTags from '@/lib/head/HeadTags'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './NotFound.module.scss'

export default memo(function NotFound() {
  return (
    <div className={style.Page}>
      <HeadTags title='Not found' />
      <Navbar withSearch />
      <main>
        <div className={style.NotFound}>
          <img src={notFoundDecorSvg} className={style.DecorSvg} alt='' />

          <h1 className={style.Heading}>We couldn&apos;t find what you&apos;re looking for</h1>
          <span className={style.Description} aria-hidden='true'>
            Try again using different keywords
          </span>
          <VisuallyHidden>
            <div role='alert'>
              <span>
                Sorry, this was a miss. We couldn&apos;t find what you&apos;re looking for.
              </span>
              <span>Try again using different keywords</span>
            </div>
          </VisuallyHidden>

          <span className={style.Helper}>
            <PrimaryButton
              onPress={() => {
                globalThis.history.back()
              }}
            >
              Go back
            </PrimaryButton>{' '}
            or contact our <Link to='/contact-us'>Support Center</Link>
          </span>
        </div>
      </main>
    </div>
  )
})
